import Box from '@mui/material/Box';
import { SwitchField } from '@openx/components-core/lib/SwitchField/SwitchField.tsx';
import { ResultsByOpenXReadonly } from '@openx/components-deal/lib/components/ResultsByOpenX/ResultsByOpenXReadonly.tsx';
import type { RboConfig } from '@openx/types/deal.ts';
import { useMemo } from 'react';

interface RBOSwitchFieldComponentProps {
  label: string;
  old_value?: string | null;
  new_value?: RboConfig | string | null;
}

export const RBOSwitchFieldComponent = (props: RBOSwitchFieldComponentProps) => {
  const rboConfig = useMemo(
    () => (typeof props.new_value === 'object' ? (props.new_value ?? undefined) : undefined),
    [props.new_value]
  );

  return (
    <>
      <SwitchField
        label={props.label}
        type="checkbox"
        checked={!props.old_value}
        data-test="toggle-results-by-openx"
        disabled
      />
      <Box
        sx={{
          marginTop: 1.5,
        }}
      >
        <ResultsByOpenXReadonly rboConfig={rboConfig} />
      </Box>
    </>
  );
};
